import './home.css'

function Home() {
  return (
    <section id="home">
      <div className="entire-title">
        <h1 className="home-title">Hi! I'm Erica</h1>
        <div>
          <h2 className='home-subtitle'>A full-stack 
            <span className='deco-subtitle-text'> developer </span>
            with an appreciation for user-friendly 
            <span className='deco-subtitle-text'> design</span>
          </h2>
        </div>
      </div>
    </section>
  )
}

export default Home